import { createAction } from '@reduxjs/toolkit';

import { ApiDomainFoldersResponse } from './domainFolders.types';

export const loadDomainFoldersStartRequest = createAction('domainFolders/load/requestStart');
export const loadDomainFoldersSuccess = createAction<ApiDomainFoldersResponse | undefined>('domainFolders/load/success');
